import { CompanyUser, JobItemsInput } from "generated/graphql";
import React from "react";
import { Order } from "../utils";

export interface INewJobContext {
  userData?: CompanyUser;
  job?: JobItemsInput;
  orders?: Order[];
  tuck?: boolean;
  setTuck?: React.Dispatch<React.SetStateAction<boolean>>;
  setJob?: React.Dispatch<React.SetStateAction<JobItemsInput>>;
  setOrders?: React.Dispatch<React.SetStateAction<Order[]>>;
  setUserData?: React.Dispatch<React.SetStateAction<CompanyUser>>;
}
export const NewJobContext = React.createContext<INewJobContext>(null);

const NewJobProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [job, setJob] = React.useState<JobItemsInput>(null);
  const [userData, setUserData] = React.useState<CompanyUser>(null);
  const [orders, setOrders] = React.useState<Order[]>([]);
  const [tuck, setTuck] = React.useState(null);
  return (
    <NewJobContext.Provider
      value={{
        tuck,
        job,
        setTuck,
        setJob,
        orders,
        setOrders,
        userData,
        setUserData,
      }}
    >
      {children}
    </NewJobContext.Provider>
  );
};

export default NewJobProvider;
